module.exports = __webpack_public_path__ + "static/media/instructions-youtube.12528373.jpg";